// extracted by css-extract-rspack-plugin
export default {"dropzone":"src-app-components-forms-AttachmentBox-AttachmentBox-module__dropzone-ZzcJz_"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"dropzone\":\"src-app-components-forms-AttachmentBox-AttachmentBox-module__dropzone-ZzcJz_\"}";
        // 1789362522827
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  